import React, { FC } from 'react';
import { Header, Footer } from 'components';
import 'sass/style.scss';
import 'swiper/swiper.min.css';
import 'swiper/swiper-bundle.min.css';
import { GlobalQuery } from 'queries/global';
import Youtube from 'assets/svg/youtube-video.svg';
import PDF from 'assets/svg/pdf.svg';
import { GlobalType } from 'types/GlobalType';

export interface LayoutProps {
  children: JSX.IntrinsicElements['div'];
}

const Layout: FC<LayoutProps> = ({ children }: any) => {
  const data: GlobalType = GlobalQuery();
  return (
    <>
      <Youtube style={{ display: 'none' }} />
      <PDF style={{ display: 'none' }} />
      <Header data={data} />
      <div>
        <main>{children}</main>
        <Footer
        data={data}
        />
      </div>
    </>
  );
};

export default Layout;
